import { createContext, useContext } from 'react';

export type SelectionHostRegistration = {
  /** Stable per-editor id (e.g. the node/block id) — keys the internal host map. */
  id: string;
  /** The contenteditable root whose selection this host owns. */
  element: HTMLElement;
  /**
   * Invoked with the live Range when the user clicks the reference button
   * while a selection inside this host's element is active. Omit to hide
   * the reference button entirely for this host (matches the B/I/U-only
   * toolbar behavior of the legacy per-host hook).
   */
  onAddReference?: (range: Range) => void;
};

export type SelectionToolbarApi = {
  /**
   * Registers `element` as a selection-toolbar host. Returns an unregister
   * function — call it on cleanup (host unmount) to remove the host and
   * its keyboard-shortcut listener, and to hide the toolbar if it was
   * currently anchored to this host.
   */
  registerSelectionHost: (registration: SelectionHostRegistration) => () => void;
};

const noopUnregister = () => {};

const noopApi: SelectionToolbarApi = {
  registerSelectionHost: () => noopUnregister,
};

export const SelectionToolbarContext =
  createContext<SelectionToolbarApi>(noopApi);

export function useSelectionToolbarApi(): SelectionToolbarApi {
  return useContext(SelectionToolbarContext);
}
